import TrackingService from './TrackingService';

export default new TrackingService();
